import React from 'react'

export const useSnackbar = () => {
  const [isActive, setIsActive] = React.useState(false)
  const [message, setMessage] = React.useState('')
  const [isSuccess, setIsSuccess] = React.useState(true)

  React.useEffect(() => {
    if (isActive === true) {
      setTimeout(() => {
        setIsActive(false)
      }, 3000)
    }
  }, [isActive])

  const openSnackBar = (
    msg: string = 'Something went wrong...',
    status: boolean
  ) => {
    setIsSuccess(status)
    setMessage(msg)
    setIsActive(true)
  }

  return { isActive, message, openSnackBar, isSuccess }
}
